"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NativeDateCalendarPopupTrigger = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = require("../../../../UIElements/Icons/PetSure/Icon");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const NativeDateCalendarPopupTrigger = _ref => {
  let {
    readOnly = false,
    dateInputElementId,
    onPopupOpen = () => {}
  } = _ref;
  const ShowCalendarPopup = event => {
    if (readOnly) {
      return;
    }
    event.preventDefault();
    const dateInputElement = document.getElementById(dateInputElementId);
    if (dateInputElement && typeof dateInputElement.showPicker === 'function') {
      if (typeof dateInputElement.focus === 'function') {
        dateInputElement.focus();
      }
      dateInputElement.showPicker();
      onPopupOpen();
    }
  };
  return !readOnly && /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "button primary icon_only inputDateCalendarButton",
    onClick: ShowCalendarPopup,
    title: "Open calendar popup. Click elsewhere or use esc key to close."
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Open calendar popup"), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: "calendar"
  }));
};
exports.NativeDateCalendarPopupTrigger = NativeDateCalendarPopupTrigger;
NativeDateCalendarPopupTrigger.propTypes = {
  dateInputElementId: _propTypes.default.string.isRequired,
  readOnly: _propTypes.default.bool,
  onPopupOpen: _propTypes.default.func
};